import { ref } from 'vue'
import { useLocale } from '@/composables/useLocale'
import { submitDocFeedback } from '@/api/docs'

export function useDocFeedback() {
  const { currentLocale } = useLocale()

  const submitting = ref(false)
  const submitted = ref(false)
  const error = ref<string | null>(null)

  async function submit(
    category: string,
    slug: string,
    helpful: boolean,
  ): Promise<void> {
    submitting.value = true
    error.value = null

    try {
      await submitDocFeedback(category, slug, {
        helpful,
        locale: currentLocale.value,
      })
      submitted.value = true
    } catch {
      error.value = 'docs.feedback.error'
    } finally {
      submitting.value = false
    }
  }

  return { submit, submitting, submitted, error }
}
